import MultipliersActions from './MultipliersActions.component';

export default MultipliersActions;
